export const courseTypeOrder = ["Core", "Elective", "PHD", "EE"];
